<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-row>
        <!-- Inicio Panel FILTRO -->
        <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
          <vs-card>
            <div slot="header">
              <h3 class="card-title mb-0">Información de filtro</h3>
            </div>
            <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
            <vs-row>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <!-- Selector de empresa -->
                <company-selector v-model="companyId"/>
              </vs-col>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <label class="vs-input--label">Fecha de inicio</label>
                <vs-input type="date" v-model="initialDate" class="w-100 "/>
              </vs-col>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <label class="vs-input--label">Fecha de fin</label>
                <vs-input type="date" v-model="finalDate" class="w-100 "/>
              </vs-col>
            </vs-row>
            <br/>
            <vs-row>
              <!-- Selector de tipo de servicio -->
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12" v-if="validateThereStations">
                <label class="vs-input--label">Estación de pago</label>
                 <multiselect
                     :key="forceRender" v-model="selectedStations" placeholder="Seleccione una estación" label="name"
                              ref="myMultiselect" track-by="code" :options="showStations" :multiple="true"
                              :taggable="false"  :max-height="150" :max="50"  :searchable="false">
                 </multiselect>
              </vs-col>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12" v-if="validateThereStations">
                <label class="vs-input--label">{{ $t('collectionReport.collectionDetail') }}</label>
                <div class="d-flex is-align-items-stretch">
                  <vs-checkbox v-model="detail">{{$t('collectionReport.collectionDetailPlaceholder')}}</vs-checkbox>
                </div>
              </vs-col>
            </vs-row>
            <vs-row>
            </vs-row>
            <hr class="custom-hr"/>
            <div class="d-inline-block d-md-flex align-items-center">
              <div class="btn-alignment">
                <vs-button :disabled="!isSearch" @click="listPreview()">Buscar</vs-button>
                <vs-button color="gray" @click="clearForm()">Limpiar</vs-button>
              </div>
              <div class="ml-auto mt-3 mt-md-0">
                <div class="d-flex align-items-center">
                  <div class="d-flex align-items-center dropdownbtn-alignment ml-3">
                    <vs-button :disabled="!isDownloadable" class="btnx" type="filled" color="danger"
                               @click="downloadReport()">
                      <i class="ti-upload mr-2"></i>Exportar
                    </vs-button>

                    <vs-dropdown>
                      <vs-button class="btn-drop" type="filled" color="danger" icon="expand_more"></vs-button>
                      <vs-dropdown-menu>
                        <vs-button class="dropdown-item" color="'default'" v-for="document in documents"
                                   :value="document.id" :key="document.id"
                                   :id="document.id" @click="formatType=document.id">{{ document.name }}
                        </vs-button>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </vs-card>
        </vs-col>
        <vs-col vs-lg="12" vs-xs="12" v-if="showTable">
          <vs-card>
            <h3 class="card-title d-flex">
              Tabla de previsualización
            </h3>
            <div class="border" style="max-height: 43em;
              overflow-y: auto;">
              <vs-table max-items="50" pagination :data="tableData">
                <template slot="thead">
                  <vs-th v-if="detail">Fecha de reporte</vs-th>
                  <vs-th>Estación o punto de pago</vs-th>
                  <vs-th>Parqueadero</vs-th>
                  <vs-th>Mensual</vs-th>
                  <vs-th>Misceláneo o producto</vs-th>
                  <vs-th>Tiquete perdido</vs-th>
                  <vs-th>Impuesto</vs-th>
                  <vs-th>Pago electrónico</vs-th>
                  <vs-th>Pago en efectivo</vs-th>
                  <vs-th>Total facturado</vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr,indextr) in data">
                    <vs-td :data="data[indextr].days" v-if="detail">
                      {{ data[indextr].days }}
                    </vs-td>
                    <vs-td :data="data[indextr].nickname">
                      {{ data[indextr].nickname ? data[indextr].nickname : data[indextr].nameDevice }}
                    </vs-td>
                    <vs-td :data="data[indextr].parking">
                      {{ data[indextr].parking }}
                    </vs-td>
                    <vs-td :data="data[indextr].monthly">
                      {{ data[indextr].monthly }}
                    </vs-td>
                    <vs-td :data="data[indextr].product">
                      {{ data[indextr].product }}
                    </vs-td>
                    <vs-td :data="data[indextr].lostTicket">
                      {{ data[indextr].lostTicket }}
                    </vs-td>
                    <vs-td :data="data[indextr].vat">
                      {{ data[indextr].vat }}
                    </vs-td>
                    <vs-td :data="data[indextr].electronicPay">
                      {{ data[indextr].electronicPay }}
                    </vs-td>
                    <vs-td :data="data[indextr].cashPay">
                      {{ data[indextr].cashPay }}
                    </vs-td>
                    <vs-td :data="data[indextr].finalTotal">
                      {{ data[indextr].finalTotal }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vs-card>
          <!-- Fin de tabla de datos -->
        </vs-col>

      </vs-row>
    </vs-col>
  </vs-row>
</template>

<script>
import CompanySelector from "@/components/Shared/CompanySelector";
import DateUtils from "@/global/DateUtils";
import Multiselect from "vue-multiselect";
import parkingReportsEndpoints from "@/endpoints/reports/parking-reports/parkingReportsEndpoints";
import {ROUTES} from "@/global/api_routes";
import toast from "@/global/ToastConfig";
import deviceEndpoint from "@/endpoints/machine/DeviceEndpoint";
import {reportNames} from "@/global/constants";

export default {
  name: 'Collection-mall',
  components: {
    CompanySelector,
    Multiselect,
  },
  data() {
    return {
      initialDate: null,
      finalDate: null,
      companyId: null,
      isLoading: false,
      documents: [
        {name: ".xlsx", id: "xlsx"},
      ],
      formatType: "xlsx",
      thereStations: false,
      selectedStations: [],
      showStations: [],
      listStations: [],
      tableData: [],
      showTable: false,
      totalsPreview: {},
      isSearch: false,
      isDownloadable: false,
      detail: false,
      forceRender: 0,
      currentRequestId: 0,
    }
  },
  computed:{
    validateThereStations() {
      return this.showStations.length > 0;
    }
  },
  mounted() {
    toast.init({context: this})
   },
  watch: {
     companyId() {
      this.showTable = false;
      this.showStations = [];
      this.tableData = [];
      this.selectedStations = [];
      this.validateStations();
      this.totalsPreview = {};
    },
     initialDate() {
      this.showTable = false;
      this.showStations = [];
      this.tableData = [];
      this.selectedStations = [];
      this.validateStations();
      this.totalsPreview = {};
    },
     finalDate() {
      this.showTable = false;
      this.showStations = [];
      this.tableData = [];
      this.selectedStations = [];
      this.validateStations();
      this.totalsPreview = {};
    },
    selectedStations() {
      this.tableData = [];
      this.totalsPreview = {};
      this.showTable = false;
    },
    showStations() {
      this.isSearch = false;
      this.isDownloadable = false;
      if (this.showStations.length > 0) {
        this.isSearch = true;
        this.isDownloadable = true;
      }
    },
    detail() {
      this.tableData = [];
      this.totalsPreview = {};
      this.showTable = false;
    }

  },
  methods: {
    /**
     * metodo que valida las fechas para traer la informacion de las estaciones
     * @returns {Promise<void>}
     */
     validateStations() {
      this.isLoading = true;
      if (!this.companyId) {
        this.thereStations = false;
        this.isLoading = false;
        return;
      }
      if (!this.finalDate || !this.initialDate) {
        this.thereStations = false;
        this.isLoading = false;
        return;
      }
       this.listDevices();
    },
    /**
     * metodo que limpia el formulario
     */
    clearForm() {
      this.companyId = null;
      this.thereStations = false;
      this.initialDate = null;
      this.finalDate = null;
      this.tableData = [];
      this.showTable = false;
      this.showStations = [];
      this.totalsPreview = {};
      this.selectedStations = [];
      this.isSearch = false;
      this.isDownloadable = false;
    },
    /**
     * metododo que le asigna el valor a los parametros para consultar y previsualizar la informacion
     * @returns {{finalDate: string, companyId: null, initialDate: string, payPoints: (*|string)}}
     */
     prepareParameters() {
      return {
        companyId: this.companyId,
        initialDate: DateUtils.toDateShortString({date: this.initialDate}),
        finalDate: DateUtils.toDateShortString({date: this.finalDate}),
        payPoints:  this.selectedStations.map(item => item.code.toString()).join(","),
        detail: this.detail,
      }
    },
    /**
     *  metodo que valida si seleccionaron una estacion o si no que tenga encuenta todas las estaciones
     * @returns {string}
     */
     getValidateStations() {
      // se valida que si no seleccionan
      //estacion me las traiga todas
      console.log('validando estaciones',this.showStations);

      return this.selectedStations.length === 0
          ? this.showStations.map(item => item.code).join(",")
          : this.selectedStations.map(item => item.code).join(",")
    },
    /**
     * metodo que valida que los parametros del formulario inicial sean los correctos
     * @returns {Promise<void>}
     */
     validateForm() {
      if (!this.companyId) {
        throw new Error("Seleccione una compañia");
      }
      if (!this.finalDate || !this.initialDate) {
        throw new Error("Debe seleccionar fecha inicial y/o fecha final");
      }
      const validationResult =  this.$validator.validateAll();
      const validateFinal = DateUtils.isValid(this.finalDate);
      const validDates = DateUtils.isBefore({
        before: this.finalDate,
        date: this.initialDate,
      });
      if (!validationResult) {
        throw new Error("Complete el formulario");
      }
      if (!validateFinal) {
        throw new Error("Debe seleccionar una fecha final igual o inferior a la actual");
      }
      if (validDates) {
        throw new Error("Fecha final no puede ser inferior a fecha inicial");
      }
    },
    /**
     * metodo de descrga del reporte
     * @returns {Promise<void>}
     */
     downloadReport() {
      try {
        this.isLoading = true;
        toast.info('reportGlobal.loadingReportLabel')
        this.validateForm();
       const objParams =  this.prepareParameters();
       const name = this.detail 
       ? reportNames.PARKING.COLLECTION_DETAIL.title 
       : reportNames.PARKING.COLLECTION.title;
       const fileName = `${name}_${DateUtils.toDateShortString({date: this.initialDate})}_${DateUtils.toDateShortString({date: this.finalDate})}`;
        parkingReportsEndpoints.downloadCollection(objParams, fileName)
          .then(() => {
            this.isLoading = false;
            toast.ok('reportGlobal.exportSuccessLabel');
          }).catch(error => {
          toast.error('reportGlobal.exportErrorLabel');
          this.isLoading = false;
        });
      } catch (error) {
        toast.error(error.toString());
        this.isLoading = false;
      }
    },
    /**
     * metodo que genera la lista para previsualizar el la informacion
     * @returns {Promise<void>}
     */
     listPreview() {
      try {
        this.validateForm();
        this.isLoading = true;
        this.tableData = [];
        const objParams =  this.prepareParameters();
        parkingReportsEndpoints.listCollection(objParams)
            .then(data => {
              if (data.info === null) {
                this.tableData = [];
                this.isLoading = false;
                return;
              }
              this.isLoading = false;
              this.tableData = data.info;
              this.showTable = true;
            });
      } catch (error) {
        toast.error(error.message);
      }
    },
    /**
     * metodo que lista las estaciones que facturaron en el rango de fecha ingresado
     * @returns {Promise<void>}
     */
    listDevices() {
      this.currentRequestId++;
      const requestId = this.currentRequestId;
      this.showStations = [];
      this.selectedStations = [];
      this.validateErrors();
      const objParams = this.prepareParameters();
      deviceEndpoint.listByBillingRange(objParams)
        .then(data => {
          if (requestId !== this.currentRequestId) {
            return;
          }
          if (data.length === 0) {
            this.isLoading = false;
            return;
          }
          data.forEach((station) => {
            const unity = {
              name: station.nickname == null ? station.title : station.nickname,
              code: station.code,
            };
            this.showStations.push(unity);
          });
          this.selectedStations = this.showStations;
          this.forceRender++;
          this.isLoading = false;
        })
        .catch(error => {
          // Verificar si esta es la solicitud más reciente
          if (requestId !== this.currentRequestId) {
            return; // Ignorar errores de solicitudes anteriores
          }
          toast.error(error.message);
          this.isLoading = false;
        });
    },
    validateErrors() {
       try {
        this.validateForm();
      } catch (error) {
        this.isLoading = false;
        toast.error(error.message);
        return;
      }
    },
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"/>